import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './pages/HomePage/HomePage';
import About from './pages/About/About';
import Disclaimer from './pages/Disclaimer/Disclaimer';
import HelpDesk from './pages/HelpDesk/HelpDesk';
import RefundPolicy from './pages/RefundPolicy/RefundPolicy';
import WinnersList from './pages/WinnersList/WinnersList';
import ProductPricing from './pages/ProductPricing/ProductPricing';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import TermsConditions from './pages/TermsConditons/TermsConditions';
import PointSystem from './pages/PointSystem/PointSystem';
import PdfViewer from './pages/PdfViewer/PdfViewer';
import PlayGuide from './pages/PlayGuide/PlayGuide';
import PaymentFailed from './pages/PaymentFailed';
import PaymentSuccess from './pages/PaymentSuccess/PaymentSuccess';
import PaymentProcess from './pages/PaymentProcess/PaymentProcess';
import './App.css';

function AppLayout() {
  const location = useLocation();

  // 🔥 Define routes where Header/Footer should *not* show
  const noHeaderFooterRoutes = ['/payment-gateway-paymentfailed','/payment-gateway-paymentsuccess','/payment-gateway-paymentprocess'];

  const shouldShowLayout = !noHeaderFooterRoutes.includes(location.pathname);

  return (
    <div className="App">
      {shouldShowLayout && <Header />}
      
      <Routes>
        <Route path="*" element={<HomePage />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/winners" element={<WinnersList />} />
        <Route path="/product-pricing" element={<ProductPricing />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/contact-us" element={<HomePage scrollToContact={true} />} />
        <Route path="/help-desk" element={<HelpDesk />} />
        <Route path="/points-system" element={<PointSystem />} />
        <Route path="/legal-opinion-skilled-game" element={<PdfViewer />} />
        <Route path="/play-guide" element={<PlayGuide />} />
        <Route path="/payment-gateway-paymentfailed" element={<PaymentFailed />} />
        <Route path='/payment-gateway-paymentsuccess' element={<PaymentSuccess/>}/>
        <Route path='/payment-gateway-paymentprocess' element={<PaymentProcess/>}/>
      </Routes>
      
      {shouldShowLayout && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
